import * as React from 'react';
import { useAppContext } from '@contexts/app/hooks/useAppContext';
import { SizeMutationEffect } from './SizeMutationEffect';
import { FitViewPortBox } from '@components/FitViewPortBox';

/**
 * build mutation effect to wrap component
 *
 * @requires ServiceContext
 * @param Component
 */
export function withEnabledResizer<TProps>(Component: React.FC<TProps>): React.FC<TProps> {
    /**
     * compose mutation effect
     * @param props
     */
    const ComponentWithEnabledResizer: React.FC<TProps> = (props: React.PropsWithChildren<TProps>) => {
        const { iframeMode, fullScreen } = useAppContext();

        if (iframeMode && !fullScreen) {
            return (
                <SizeMutationEffect>
                    <Component {...props} />
                </SizeMutationEffect>
            );
        }

        // If not within iframe, use full screen by default
        return (
            <FitViewPortBox position="relative">
                <Component {...props} />
            </FitViewPortBox>
        );
    };

    ComponentWithEnabledResizer.displayName = `${Component.displayName}WithEnabledResizer`;

    return ComponentWithEnabledResizer;
}
